import React, { useState } from "react";
import LandingPage from "./LandingPage";
import "./SessionTimeOutPage.scss";
import Header from "../components/layout/Header";
import TimerModal from "../components/shared/TimerModal";
import { APP_Config } from "../utils/AppConfig";

const SessionTimeOutPage = (props: any) => {
  const [secondPopUp, setSecondPopUp] = useState<boolean>(true);

  const directLogout = () => {
    const accesstoken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    window.location.href = `${APP_Config().REACT_APP_LOGOUT
      }?accesstoken=${accesstoken}&refreshtoken=${refreshToken}&sessionExpired=false&clientId=${APP_Config().REACT_APP_CLIENT_ID
      }`;

    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("errorMessageList");
    sessionStorage.removeItem("archiveData")
  };

  const secondConfirmClose = (value: string) => {
    if (value === "Dismiss") {
      setSecondPopUp(false);
      // window.open("", "_blank");
      window.close();
    } else if (value === "Login") {
      setSecondPopUp(false);
      directLogout();
    }
  };

  const sessionExpiredText = () => (
    <>
      <span>
        Your session has timed out. <br />
        Please log in again.
      </span>
    </>
  );

  return (
    <div className="sessionTimeOutPage">
      <Header LogoData={props?.LogoData} />
      <div className="secondPart"> </div>
      <TimerModal
        className="confirmLeadCreated moveContactModal timer"
        headerText={"Session Expired"}
        confirmCloseHandle={secondConfirmClose}
        firstBtn={"Dismiss"}
        secondBtn={"Login"}
        confirmCloseModel={secondPopUp}
        confirmText={sessionExpiredText()}
      />
    </div>
  );
};

export default SessionTimeOutPage;
